import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React, { useRef, useState, useCallback, useEffect } from 'react';
import classnames from 'classnames';
import { useIsOverflowed } from '@wix/da-hooks/pkg/useIsOverflowed';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import { DEFAULT_COLLAPSED_HEIGHT } from '../../constants';
import s from './ExpandableWrapper.scss';
const NO_TOGGLE_HEIGHT_ADJUST = 32;
const ExpandableWrapper = ({ contentContainerRef: propsOverflowRef, collapsedHeight = DEFAULT_COLLAPSED_HEIGHT, allowExpansion, forceShowToggle, toggleButton, toggleButtonHref, toggleButtonBiData, toggleButtonContents, overflowCacheKey, onExpansion, onOverflowMeasured, children })=>{
    const defaultOverflowRef = useRef(null);
    const contentContainerRef = propsOverflowRef || defaultOverflowRef;
    const { isOverflowed, isReady: isOverflowMeasured } = useIsOverflowed(contentContainerRef, undefined, overflowCacheKey);
    useEffect(()=>{
        isOverflowMeasured && onOverflowMeasured && onOverflowMeasured();
    }, [
        isOverflowMeasured,
        onOverflowMeasured
    ]);
    const [expanded, setExpanded] = useState(false);
    const toggleExpanded = useCallback((event)=>{
        event.preventDefault();
        setExpanded((value)=>{
            onExpansion && onExpansion(value);
            return !value;
        });
    }, [
        onExpansion
    ]);
    const collapsedHeightLimit = toggleButtonContents ? collapsedHeight : collapsedHeight - NO_TOGGLE_HEIGHT_ADJUST;
    const isShowingToggleButton = isOverflowed && !expanded || forceShowToggle;
    return /*#__PURE__*/ React.createElement("div", _object_spread({
        className: classnames(s['root'], !expanded && s['collapsed'])
    }, !expanded && {
        style: {
            maxHeight: collapsedHeightLimit
        }
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['content'],
        ref: contentContainerRef
    }, children), isShowingToggleButton && (toggleButton || /*#__PURE__*/ React.createElement(TextButton, {
        className: classnames(s['toggle-button'], !toggleButtonContents && s['no-button-text']),
        variant: "main",
        size: "medium",
        onClick: allowExpansion ? toggleExpanded : undefined,
        href: toggleButtonHref,
        isFakeButton: !allowExpansion && !toggleButtonHref,
        biData: toggleButtonBiData,
        noHorizontalPaddings: false
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['toggle-button-contents']
    }, toggleButtonContents))));
};
ExpandableWrapper.displayName = 'ExpandableWrapper';
export default ExpandableWrapper;
